<content>
    <div class="info">{{'global.infoRequired' | translate}}</div>
    <div>
    <h2>{{'mantenimientoEtiquetadores.etiquetador.titulo' | translate}}</h2>
    <form [formGroup]="newEditForm" [ngClass]="{'show-error':showError}">
        <div [ngClass]="this.isSmallScreen ? 'entry-5-modal' : 'entry-4-modal'">
            <label>{{'mantenimientoEtiquetadores.etiquetador.etiquetador' | translate}} *</label>
            <input type="text" formControlName="des" [maxlength]="50">
        </div>
        <div [ngClass]="this.isSmallScreen ? 'entry-5-modal' : 'entry-4-modal'">
            <label>{{'mantenimientoEtiquetadores.etiquetador.cif' | translate}}</label>
            <input type="text" formControlName="nifcif">
        </div>
        <div [ngClass]="this.isSmallScreen ? 'entry-5-modal' : 'entry-4-modal'" class="alignment-start"  *ngIf="etiquetadorId">
            <input type="checkbox" id="etqAutorizado" formControlName="etqAutorizado">
            <label for="etqAutorizado">{{'mantenimientoEtiquetadores.etiquetador.etiquetado' | translate}}</label>
        </div>
        <div [ngClass]="this.isSmallScreen ? 'entry-5-modal' : 'entry-4-modal'" class="alignment-start" *ngIf="etiquetadorId">
            <input type="checkbox" id="etqReimp" formControlName="etqReimp">
            <label for="etqReimp">{{'mantenimientoEtiquetadores.etiquetador.reetiquetado' | translate}}</label>
        </div>
        <div [ngClass]="this.isSmallScreen ? 'entry-5-modal' : 'entry-4-modal'">
            <label>{{'mantenimientoEtiquetadores.etiquetador.alias' | translate}} <i class="fas fa-info-circle"
                title="{{'titles.introduceAlias' | translate}}"></i></label>
            <input type="text" formControlName="alias" [maxlength]="25">
        </div>
        <div [ngClass]="this.isSmallScreen ? 'entry-5-modal' : 'entry-4-modal'">
            <label>{{'mantenimientoEtiquetadores.etiquetador.domicilio' | translate}} *</label>
            <input type="text" formControlName="domicilioFiscal">
        </div>
        <div [ngClass]="this.isSmallScreen ? 'entry-5-modal' : 'entry-4-modal'">
            <label>{{'mantenimientoEtiquetadores.etiquetador.domicilioAlias' | translate}} <i class="fas fa-info-circle"
                title="{{'titles.introduceAlias' | translate}}"></i></label>
            <input type="text" formControlName="domicilioFiscalAlias">
        </div>
    </form>
    </div>
    <div class="double-form">
        <h2 *ngIf="!etiquetadorId">{{'mantenimientoEtiquetadores.etiquetador.paisDenominacion' | translate}}</h2>
        <form *ngIf="!etiquetadorId" [formGroup]="newEditForm" [ngClass]="{'show-error':showError}">
            <div [ngClass]="this.isSmallScreen ? 'entry-5-modal' : 'entry-4-modal'">
                <label>{{'global.pais' | translate}} *</label>
                <app-filterable-list class="shorter-list" [itemsList]="paises" [selectedItem]="newEditForm.get('pais')" [placeHolder]="false"></app-filterable-list>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-5-modal' : 'entry-4-modal'">
                <label>{{'mantenimientoEtiquetadores.etiquetador.denominacion' | translate}} *</label>
                <app-filterable-list class="shorter-list" [itemsList]="denominaciones" [selectedItem]="newEditForm.get('denominacionId')" [disabled]="disabled" [placeHolder]="false"></app-filterable-list>
            </div>
            <td [ngClass]="this.isSmallScreen ? 'entry-5-modal' : 'entry-4-modal'" class="alignment-start">
                <input type="checkbox" id="autorizado" formControlName="autorizado">
                <label for="autorizado">{{'mantenimientoEtiquetadores.etiquetador.etiquetado' | translate}} *</label>
            </td>
            <td [ngClass]="this.isSmallScreen ? 'entry-5-modal' : 'entry-4-modal'" class="alignment-start">
                <input type="checkbox" id="reimp" formControlName="reimp">
                <label for="reimp">{{'mantenimientoEtiquetadores.etiquetador.reetiquetado' | translate}} *</label>
            </td>
        </form>
    </div>
</content>
<footer class="button-bar-right">
    <button class="secondary" (click)="close()">{{'global.cancelar' | translate}}</button>
    <button (click)="save()">{{etiquetadorId ? ('global.actualizar' | translate) : ('global.insertar' | translate)}}</button>
</footer>
<app-toast *ngIf="(showError || showApiError) && mensajes" [messages]="mensajes" (closed)="showError=$event;showApiError=$event"></app-toast>
